export default __webpack_public_path__ + "static/OYOY-3716x752-60fps-3c1fff04c25abc687bdfc2116290bbcc.mp4";